import { device } from '@/components/templates/displays/devices'
import * as React from 'react'
import styled from 'styled-components'
import BannerViewIconMobile from '../statefullIcons/bannerViewIconMobile'
import GridViewIconMobile from '../statefullIcons/gridViewIconMobile'

const ViewsContainer = styled.section`
    @media ${device.beyond_ipad_mobile} {
        display: none;
    }
    position: relative;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    max-width: 100vw;
    margin-top: 25px;
    border-top: px solid black;
    border-top: 1px solid #f0f0f0;
    z-index: 0;
`

const Item = styled.button<StyleProps>`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 50px;
    margin-bottom: 4px;

    :focus {
        outline: 0;
    }
    border: none;
    background-color: white;
`

const Line = styled.div<IsActiveProps>`
    position: absolute;
    width: 50%;
    height: 2px;
    background-color: #2a979a;
    transform: ${(props) =>
        props.isGridView === true ? 'translateX(50%)' : 'translateX(-50%)'};
    top: 50px;
    transition: all 150ms;
`

interface Props {
    activeView: string
    setGridView: any
    setBannerView: any
}

interface StyleProps {
    isActive: boolean
}

interface IsActiveProps {
    isGridView: boolean
}

class ViewsMenuMobile extends React.Component<Props, {}> {
    componentDidMount() {}

    render() {
        const { activeView, setBannerView, setGridView } = this.props

        return (
            <ViewsContainer>
                <Item
                    onClick={(e: any) => {
                        e.preventDefault()
                        setGridView()
                    }}
                    isActive={activeView === 'grid_view' ? true : false}
                    data-attr="grid_view_mobile"
                >
                    <GridViewIconMobile
                        isActive={activeView === 'grid_view' ? true : false}
                    />
                </Item>
                <Item
                    onClick={(e: any) => {
                        e.preventDefault()
                        setBannerView()
                    }}
                    isActive={activeView === 'banner_view' ? true : false}
                    data-attr="banner_view_mobile"
                >
                    <BannerViewIconMobile
                        isActive={activeView === 'banner_view' ? true : false}
                    />
                </Item>

                <Line isGridView={activeView === 'grid_view' ? false : true} />
            </ViewsContainer>
        )
    }
}

export default ViewsMenuMobile
